module.exports = __webpack_public_path__ + "assets/images/img/Notifications-01.c9312e9288040a71b79fdd8b8b139ece.png";